import { useUser } from "../../contexts/useUserData";
import { useChat } from "../../contexts/useChatData";
import { useEffect, useState } from "react";
import { receiveFavQuestions, deleteFavQuestion } from "../../api";
import styles from "./favStyles.module.css";
import SVGMessage from "../../assets/svgComponents/Message";
import { PopupFavQuestions } from "./PopupFavQuestions";
import { PopupDeleteFavQuestions } from "./PopupDeleteFavQuestion";

interface props {
    menuOpen: Function;
}

export const FavComponent = (propsData: props) => {
    const { user, favQuestions, pushReceivedFavQuestions, removeFavQuestions, removeOneFavQuestion, scope, acceso, seccion, loginMethod } = useUser();
    const { isLoading } = useChat();

    async function deleteOneQuestion(question: string, index: number) {
        const result = await deleteFavQuestion({ question: question ,scope: scope!, acceso:acceso!, ButtonClickTime: Date.now()});
        console.log(result);
        removeOneFavQuestion!(index);
    }

    async function pullFavQuestions() {
        const result = await receiveFavQuestions(scope!, seccion!, loginMethod!);
        console.log(result);
        removeFavQuestions!();
        const arrayFavQuestions = result.map(element => {
            return element.question;
        });
        pushReceivedFavQuestions!(arrayFavQuestions);
    }

    const [indexOpenedPopup, setIndexOpenedPopup] = useState<number | null>(null);

    useEffect(() => {
        const favoritesElement = document.getElementById("favorites");

        if (favoritesElement) {
            if (isLoading) {
                favoritesElement.setAttribute("disabled", "true");
                favoritesElement.classList.add("disabled-opacity");
            } else {
                favoritesElement.removeAttribute("disabled");
                favoritesElement.classList.remove("disabled-opacity");
            }
        }
    }, [isLoading]);

    useEffect(() => {
        pullFavQuestions();
    }, []);
    useEffect(() => {
        pullFavQuestions();
    }, [scope]);
    function closePopup(index: number) {
        if (indexOpenedPopup === index) return false;
        else return true;
    }
    return (
        <div id="favorites" className={styles.favContainer}>
            <div className={styles.favQuestions}>
                {favQuestions &&
                    favQuestions.length > 0 &&
                    favQuestions.map((element, index) => {
                        return (
                            <div className={styles.favBlock} key={index}>
                                <div className={styles.iconMessage}>
                                    <SVGMessage />
                                </div>
                                <PopupFavQuestions content={element} menuOpen={propsData.menuOpen} />
                                <PopupDeleteFavQuestions
                                    index={index}
                                    deleteQuestion={deleteOneQuestion}
                                    signalPopup={setIndexOpenedPopup}
                                    closePopup={closePopup(index)}
                                />
                                <div className={styles.detailedQuestion}>
                                    <span>{element}</span>
                                </div>
                            </div>
                        );
                    })}
                {favQuestions && favQuestions.length === 0 && (
                    <div>
                        <p className={styles.defaultMessage}>Actualmente no tienes preguntas favoritas guardadas.</p>
                    </div>
                )}
            </div>
        </div>
    );
};
